var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBackBtn)?_c('div',{staticClass:"common-back"},[_c('som-icon',{attrs:{"name":"arrow-left","color":"#ff571a"},nativeOn:{"click":function($event){return _vm.goBack.apply(null, arguments)}}}),_vm._v(_vm._s(_vm.title))],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218f3f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/back.vue
// module id = null
// module chunks = 